import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Title from "@streeteasy/design-system/deprecated/Title";
import Tooltip from "@streeteasy/design-system/legacy/Tooltip";

const AddToCalendarContainer = styled.div`
  align-items: center;
  display: flex;
`;

const AddToCalendarCTA = styled(Title).attrs({ type: "secondarySmCaps" })`
  color: ${colors.primary};
`;

const StyledTooltip = styled(Tooltip)`
  [class*="styled__TooltipContent"] {
    padding: 10px 24px;
  }

  span {
    &::before {
      color: white;
      font-size: 37px;
    }
  }
`;

AddToCalendarCTA.displayName = "AddToCalendarCTA";

export { AddToCalendarContainer, AddToCalendarCTA, StyledTooltip };
